import React from 'react'
import { getCookie } from '../../../../../utilities/functions';
import PBAPIClient from '../../../../../services/prime-client'
import { usePageContext } from "../../../contexts/page.context";
import { AxiosError } from 'axios';
import { toast } from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import InfoIcon from '../../../components/Info.icon';
import SuccessIcon from '../../../icons/Success.icon';
import useSendFundsStore from '../store';
import { DestOptions } from '../constants';

const useDeleteAddress = () => {
    const { lightMode } = usePageContext()
    const queryClient = useQueryClient();
    const authToken = getCookie("authToken");
    const destination = useSendFundsStore(s => s.firstDetails.destination)
    const apiClient = new PBAPIClient('/transaction/delete-saved', authToken)

    const showError = (error) => {
        if (error instanceof AxiosError) {
            toast.remove("loading")
            toast.error(error.response?.status === 500 ?
                "Network Error" : error.response?.data, {
                position: "top-right",
                style: {
                    fontSize: "14px",
                    color: lightMode ? "black" : "white",
                    borderRadius: "4px",
                    backgroundColor: lightMode ? "#f9f9f9" : "#01293E"
                }
            })
        } else
            throw error
    }

    return useMutation({
        mutationFn: (id) => apiClient.delete(id),
        onMutate() {
            toast.loading("Deleting address.", {
                icon: <InfoIcon />,
                id: "loading",
                duration: 1000,
                position: "top-right",
                style: {
                    fontSize: "14px",
                    color: lightMode ? "black" : "white",
                    borderRadius: "4px",
                    backgroundColor: lightMode ? "#f9f9f9" : "#01293E"
                }
            })
        },
        onSuccess() {
            toast.success("Address has been deleted!", {
                icon: <SuccessIcon />,
                position: "top-right",
                style: {
                    fontSize: "14px",
                    boxShadow: "none",
                    color: lightMode ? "black" : "white",
                    borderRadius: "8px",
                    border: `1px solid ${lightMode ? "#e1e1e1" : "#343C40"}`,
                    backgroundColor: lightMode ? "#f9f9f9" : "#01293E"
                }
            })
            queryClient.refetchQueries("saved addresses", destination === DestOptions[1] ? "crypto" : "wire-transfer")
        },
        onError(error) {
            showError(error)
        }
    })
}

export default useDeleteAddress